var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActSidenavWebinar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 75H25C16.3748 74.9896 9.38535 68.0002 9.375 59.375V28.125C9.38535 19.4998 16.3748 12.5104 25 12.5H75C83.6252 12.5104 90.6146 19.4998 90.625 28.125V59.375C90.6146 68.0002 83.6252 74.9896 75 75ZM25 18.75C19.8223 18.75 15.625 22.9473 15.625 28.125V59.375C15.625 64.5527 19.8223 68.75 25 68.75H75C80.1777 68.75 84.375 64.5527 84.375 59.375V28.125C84.375 22.9473 80.1777 18.75 75 18.75H25Z",
    fill: "#9834F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.25 87.5H18.75C17.024 87.5 15.625 86.101 15.625 84.375C15.625 82.649 17.024 81.25 18.75 81.25H81.25C82.976 81.25 84.375 82.649 84.375 84.375C84.375 86.101 82.976 87.5 81.25 87.5Z",
    fill: "#9834F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1006 60.2228C40.6553 60.2073 37.866 57.4181 37.8506 53.9728V33.5384C37.8506 30.0866 40.649 27.2884 44.1008 27.2886C45.1979 27.2886 46.2756 27.5774 47.2256 28.1259L64.91 38.3384C67.8992 40.0644 68.9232 43.8868 67.1973 46.8761C66.6488 47.8261 65.86 48.6147 64.91 49.1634L47.2256 59.3759C46.277 59.929 45.1988 60.2212 44.1006 60.2228ZM61.7881 43.7509L44.1006 33.5384V53.9634L61.7881 43.7509Z",
    fill: "#9834F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActSidenavWebinar);
export default __webpack_public_path__ + "static/media/act_sidenav_webinar.f49df2db6404cce736082b47a5303631.svg";
export { ForwardRef as ReactComponent };